<template>
<!-- 联系我们信息 -->
    <div>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="name" label="姓名" max-width="70"></el-table-column>
            <el-table-column prop="phone" label="手机" max-width="70"></el-table-column>
            <el-table-column prop="email" label="电子邮箱" max-width="70"></el-table-column>
            <el-table-column prop="email" label="邮箱" max-width="70"></el-table-column>
            <el-table-column prop="content" label="内容" min-width="400"></el-table-column>
            <el-table-column label="操作" max-width="70">
                <template slot-scope="scope" >
                    <el-popconfirm title="确定要删除吗？" icon="el-icon-info" icon-color="red" @confirm="deleteJContactUs(scope.row.id)">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <div class="block">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="10"
                    layout="sizes, prev, pager, next"
                    :total="count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
// listContactUs      查询联系我们信息
// deleteContactUs    删除联系我们信息
import { 
listContactUs,
deleteContactUs} from '@/service'
export default {
    name: 'YinshiOffcialwebsiteContactUs',

    data() {
        return {
            // 分页
            pageObj:{
                page:1,
                pageSize:10,
            },
            count:0,
            // 求职者
            tableData: [],
        };
    },

    mounted() {
        
    },
    methods: {
        // 每页多少条
        handleSizeChange(val){
            this.pageObj.pageSize = val
            this.selectJContactUs()
        },
        // 页码
        handleCurrentChange(val){
            this.pageObj.page = val
            this.selectJContactUs()
        },
        // 查询求职者列表
        async selectJContactUs(){
            let res = await listContactUs({page:this.pageObj.page,pageSize:this.pageObj.pageSize});
            // 学历信息
            this.count = res.page.count
            this.tableData = res.data
        },
        // 删除
        async deleteJContactUs(id){
            let res = await deleteContactUs(id);
            if(res.code == 200){
                this.$message({ message: '删除成功！', type: 'success' });
                this.selectJContactUs()
            }else{
                this.$message({message: '删除失败！',type: 'error'});
            }
        },
    },
    created(){
        this.$store.state.adminCurrentRouter = this.$route.path  //获取当前页面路由
        this.selectJContactUs()
    }
};
</script>

<style lang="scss">
.personalInfo .recruit{
    .el-form-item__label{
        width: 120px !important;
    }

}
</style>
<style lang="scss" scoped>
// 分页
.pagination{
    padding: 50px 270px 30px 270px;
    text-align: center;
}
</style>